import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-prestation-info',
  standalone: true,
  imports: [FormsModule,CommonModule],
  templateUrl: './prestation-info.component.html',
  styleUrl: './prestation-info.component.css'
})
export class PrestationInfoComponent {
  @Input() itemPrestation:any={}

}
